import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { PlansProvider } from './context/PlansContext';
import './index.css';

const container = document.getElementById('root')!;

const app = (
  <StrictMode>
    <BrowserRouter>
      <PlansProvider>
        <App />
      </PlansProvider>
    </BrowserRouter>
  </StrictMode>
);

// Página gerada no build já chega com o HTML pronto: o React só assume por cima,
// sem apagar e redesenhar (o que piscaria a tela e atrasaria a maior imagem).
// No `npm run dev` e nas páginas de transação o contêiner vem vazio.
if (container.firstElementChild) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
